export default __webpack_public_path__ + "static/media/16.04d616cf.jpg";